import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useEntryFormContext } from 'context/EntryFormContext';
import { TabSelector } from 'components/TabSelector';
import styles from 'pages/Schedule/CreateEntry/CreateEntry.scss';

export const HallSelector = () => {
  const { form, halls, hallIndex, setHallIndex } = useEntryFormContext();

  useEffect(() => {
    if (halls.length > 0) {
      form.setFieldValue('hallID', halls[hallIndex].id);
    }
  }, [hallIndex, halls, form]);

  if (!halls?.length || halls.length <= 1) {
    return null;
  }

  return (
    <>
      <span className={styles.fieldName}>
        <FontAwesomeIcon icon={faLocationDot} />
        Зала
      </span>
      <TabSelector defaultActiveIndex={hallIndex} tabs={halls.map(({ name }) => name)} onTabChange={setHallIndex} />
    </>
  );
};
